import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import IconNext from '@material-ui/icons/KeyboardArrowRight';
import IconPrev from '@material-ui/icons/KeyboardArrowLeft';

const styled = withStyles(theme => {
  return {
    root: {},
    content: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    actions: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    button: {
      margin: theme.spacing.unit
    }
  };
});

class Pagination extends React.Component {
  render() {
    const { classes, total, page, perPage, onNext, onPrev } = this.props;
    const start = page * perPage;
    const to = start + perPage;

    return (
      <Paper className={classes.root}>
        <Toolbar className={classes.content}>
          <Typography>
            Showing {start} - {to} of {total}
          </Typography>
          <div className={classes.actions}>
            <IconButton
              className={classes.button}
              aria-label="Prev Page"
              disabled={start === 0}
              onClick={onPrev}
            >
              <IconPrev />
            </IconButton>
            <Typography>Page {page}</Typography>
            <IconButton
              className={classes.button}
              aria-label="Next Page"
              disabled={to >= total}
              onClick={onNext}
            >
              <IconNext />
            </IconButton>
          </div>
        </Toolbar>
      </Paper>
    );
  }
}

export default styled(Pagination);
